import { Box, WizardStepRenderParams, useOnNext } from '@factorialco/deprecated-design-system'
import { F0Text } from '@factorialco/f0-react'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import {
  LedgerAccountOption,
  LedgerAccountPartialValue,
  LedgerAccountSelectorF0,
  formatAccountName,
} from 'modules/banking/components/LedgerAccountSelectorF0'
import { WizardData } from 'modules/banking/components/NewAccountModal/types'
import { WizardStepLayout } from 'modules/banking/components/NewAccountModal/wizardSteps/WizardStepLayout'

export const LedgerAccountLinkStepF0 = ({
  data,
  onDataChanged,
}: WizardStepRenderParams<WizardData>) => {
  useOnNext(() => Promise.resolve())

  const selectedAccount = useUnsafeMemo((): LedgerAccountPartialValue | null => {
    if (!data.ledgerAccountId) return null
    return {
      id: data.ledgerAccountId,
      name: data.ledgerAccountName?.split(' - ')[1] ?? null,
      number: data.ledgerAccountName?.split(' - ')[0] ?? null,
    }
  }, [data.ledgerAccountId, data.ledgerAccountName])

  const handleChange = useUnsafeCallback(
    (account: LedgerAccountOption | null) => {
      onDataChanged({
        ...data,
        ledgerAccountId: account?.id ?? null,
        ledgerAccountName: formatAccountName(account) ?? null,
      })
    },
    [data, onDataChanged]
  )

  return (
    <WizardStepLayout
      title={i18n.t('banking.accounts.finish_wizard.step_2.title')}
      subtitle={i18n.t('banking.accounts.finish_wizard.step_2.subtitle')}
    >
      <Box style={{ width: '500px' }} flexNoShrink flexDirection="column" gap="s16">
        <F0Text
          variant="body"
          content={i18n.t('banking.accounts.accounting.accounting_account_label')}
        />
        <Box width="full">
          {!!data.legalEntity && (
            <LedgerAccountSelectorF0
              legalEntityId={data.legalEntity.id}
              value={selectedAccount}
              types={['bank']}
              onChange={handleChange}
            />
          )}
        </Box>
      </Box>
    </WizardStepLayout>
  )
}
